<template>
  <filter-template
    @submit="filter()"
    @clear="clearFilter()"
  >
    <v-container
      class="pa-0"
    >
      <v-layout
        row
        wrap
      >
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataInicial"
            :rules="[dateLesserThan(payload.dataFinal)]"
            :label="$t('support.components.reports.initialDate')"
            required
          />
        </v-flex>
        <v-flex
          xs12
          md6
        >
          <date-picker
            v-model="payload.dataFinal"
            :rules="[dateGreaterThan(payload.dataInicial)]"
            :label="$t('support.components.reports.finalDate')"
            required
          />
        </v-flex>
        <v-flex
          xs12
          lg12
        >
          <input-select
            v-model="payload.filtroStatus"
            :items="status"
            item-text="text"
            item-value="value"
            clearable
            multiple
            :label="$t('app.financial.chargePayment.filter.status')"
            :return-object="false"
            hide-details
          />
        </v-flex>
      </v-layout>
    </v-container>
  </filter-template>
</template>

<script>
import FilterTemplate from 'Support/components/filter-component/FilterTemplate.vue';
import FilterMixin from 'Support/mixins/FilterMixin';
import RulesMixin from 'Support/mixins/rules-mixin';
import InputSelect from 'Support/components/inputs/InputSelect.vue';
import DatePicker from 'Support/components/pickers/DatePicker.vue';
import { statusCobrancasSgv as status } from 'App/financial/utils';

export default {
  name: 'SgvChargePaymentsFilter',
  components: {
    FilterTemplate,
    InputSelect,
    DatePicker,
  },
  mixins: [FilterMixin, RulesMixin],
  data() {
    return {
      menuInitialDate: false,
      menuFinalDate: false,
      payload: {
        dataInicial: '',
        dataFinal: '',
        filtroStatus: [],
      },
      status,
    };
  },
  methods: {
    prepareFilter() {
      const preparedPayload = { ...this.payload };
      preparedPayload.filtroStatus = preparedPayload.filtroStatus.join(',');
      return preparedPayload;
    },
  },
};
</script>
